export default {
  GET_ALL: 'getAllUnomiConfigs',
  SAVE_UNOMI_CONFIG: 'saveUnomiConfig',
  DELETE_UNOMI_CONFIG: 'deleteUnomiConfig',
}